import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/SELECT_SESSION_MODAL';

export const {action: showSessionModal} = createAction(
    `${domain}/SHOW`,
    (show, institutionId, ignoreSessionIds, successAction, successData) => ({
        show,
        institutionId,
        ignoreSessionIds,
        successAction,
        successData,
    }),
);

export const {action: hideSessionModal} = createAction(`${domain}/HIDE`, data => ({data}));
